import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { resourceDetailsQueryKeys } from './resourceDetailsQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryPageResourceMarkdown = (resource, queryOptions) => {
  const query = useQuery({
    queryKey: resourceDetailsQueryKeys.pageMarkdown(resource),
    queryFn: async (params) => {
      const safeTextUrl = params.queryKey[1];
      const response = await fetch(safeTextUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch page markdown from ${safeTextUrl}`);
      }
      return response.text();
    },
    placeholderData: keepPreviousData,
    staleTime: 1e3 * 60 * 60 * 24,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!resource?.data.webpage?.reader?.url,
      queryOptions?.enabled
    ])
  });
  return query;
};

export { useQueryPageResourceMarkdown };
//# sourceMappingURL=useQueryPageResourceMarkdown.js.map
